import { useEffect, useState } from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { readPolicies, type PolicyDocument } from '@/lib/auth/policies';

export default function PolicyPage() {
  const location = useLocation();
  const [params] = useSearchParams();
  const id = params.get('document');
  const type = location.pathname === '/terms' ? 'terms_of_service' : 'privacy_policy';
  const [document, setDocument] = useState<PolicyDocument | null>(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    setDocument(null); setError('');
    readPolicies(id ?? undefined).then((documents) => {
      const found = documents.find((item) => item.document_type === type);
      if (!found) throw new Error('This policy document was not found.');
      if (active) setDocument(found);
    }).catch((failure) => { if (active) setError(failure instanceof Error ? failure.message : 'Policies are unavailable.'); });
    return () => { active = false; };
  }, [id, type]);
  return <main className="min-h-screen overflow-x-hidden bg-background-50 px-4 py-8 text-foreground-950">
    <article className="mx-auto flex max-w-3xl flex-col gap-6 border border-foreground-200 bg-background-50 p-6">
      <h1 className="text-2xl font-bold">{document?.title ?? (type === 'terms_of_service' ? 'Terms of Service' : 'Privacy Policy')}</h1>
      {error ? <p role="alert">{error}</p> : !document ? <p role="status">Loading policy...</p> : <>
        <p className="text-sm">Version: {document.version} · Language: {document.locale}</p>
        {document.is_development && <p role="note" className="border border-foreground-200 p-4 font-semibold">Development draft — for testing only. Not approved for production.</p>}
        {/* Render text safely; policy content is never injected as HTML. */}
        <div className="whitespace-pre-wrap break-words leading-7">{document.content}</div>
      </>}
      <Link to="/signup" className="flex min-h-11 items-center text-primary-600 underline focus-visible:ring-2">Back to signup</Link>
    </article>
  </main>;
}
